const textColorProp = color => ({
  theme
}) => {
  if (!color) return '';
  if (color === 'inherit') return 'color: inherit;';
  return `color: ${theme.designTokens.colors[color]};`;
};

export { textColorProp };
//# sourceMappingURL=textColorProp.js.map
